module.exports = __webpack_public_path__ + "img/logo-psychoterapia-uzaleznienia-michal-paczka.4d64def6.jpg";